import { render, staticRenderFns } from "./StartMonths.vue?vue&type=template&id=089c46e7"
import script from "./StartMonths.vue?vue&type=script&lang=js"
export * from "./StartMonths.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports